import { ReservationTimeState, ServiceOrderState } from '@mews-commander/data-access';
import { SimpleDataReservation } from '@mews-commander/types';
import {
    ReservationTimeState as ServerReservationTimeState,
    ServiceOrderState as ServerServiceOrderState,
} from '@mews-commander/legacy-data-structures';

const unconfirmedStatuses = [ServiceOrderState.Inquired, ServiceOrderState.Optional, ServiceOrderState.Requested];

interface LocalDay {
    startUtc: string;
    endUtc: string;
}

export interface DateAndTimeStrings {
    nowUtc: string;
    localDay: LocalDay;
}

export const isBetween = (dateTimeUtc: string, localDay: LocalDay) =>
    localDay.startUtc <= dateTimeUtc && dateTimeUtc <= localDay.endUtc;

export function calculateTimelineResourceUseTimeState(
    resourceUse: SimpleDataReservation,
    { localDay, nowUtc }: DateAndTimeStrings
) {
    const orderState = resourceUse.serviceOrderState;
    const isUnconfirmed = unconfirmedStatuses.includes(orderState);

    if (isUnconfirmed) {
        if ((resourceUse.releasedUtc ?? resourceUse.startUtc) > nowUtc) {
            return ReservationTimeState.ToBeConfirmed;
        }
        return ReservationTimeState.ConfirmationMissed;
    }

    if (orderState === ServiceOrderState.Confirmed) {
        if (resourceUse.startUtc > localDay.endUtc) {
            return ReservationTimeState.Future;
        }
        if (isBetween(resourceUse.startUtc, localDay)) {
            return ReservationTimeState.ToBeCheckedIn;
        }
        return ReservationTimeState.CheckInMissed;
    }
    if (orderState === ServiceOrderState.Started) {
        if (localDay.endUtc < resourceUse.endUtc) {
            return ReservationTimeState.CheckedIn;
        }
        if (isBetween(resourceUse.endUtc, localDay)) {
            return ReservationTimeState.ToBeCheckedOut;
        }
        return ReservationTimeState.CheckOutMissed;
    }
    return ReservationTimeState.Past;
}

export const convertResourceTimeStateToServerEnum = (resourceUseTimeState: ReservationTimeState) =>
    ServerReservationTimeState.getByName(resourceUseTimeState);

export const convertResourceStateToServerEnum = (reservationOrderState: ServiceOrderState) =>
    ServerServiceOrderState.getByName(reservationOrderState);
